import { MixpanelHelpers } from "./mixpanel";

/**
 * Initialize client-side services that should run on every page load.
 * This starts Mixpanel initialization but doesn't block on it.
 * Call this at the top of every client.ts file before hydrating React.
 */
export const initializeClient = () => {
  // Start Mixpanel initialization (non-blocking)
  MixpanelHelpers.initialize().then(() => {
    // Register user agent information after Mixpanel is ready
    MixpanelHelpers.registerUserAgent();

    // Register viewport orientation information after Mixpanel is ready
    MixpanelHelpers.registerViewportOrientation();
  });

  // Add any other global client-side initializations here
};
